import { setApi_host } from '@/utils/request'
export async function verifyChannel() {
  // 渠道包验证 渠道包不对使用默认数据
  // await verifyChannel({ data: getChannelCode() }).then((res) => {
  let channelID = '1913226797825179650'
  let url = `/dom/apps/dom/${channelID}`
  // let url = `http://localhost:8080/dom/${channelID}`
  // let url ='https://guide-caol.saas-xy.com:1443/dom/1917127021567737858'
  await fetch(url, {
    method: 'GET',
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate', // HTTP 1.1
      Pragma: 'no-store', // HTTP 1.0
      Expires: '0' // Proxies
    }
  })
    .then(async (response) => {
      let apiArr = JSON.parse(atob(await response.text())).api
      await checkDomain(apiArr)
    })
    .then((data) => {
      console.log(data, 'datadata')
    })
    .catch((error) => console.log('Error fetching data:', error))
  // })
}
async function checkDomain(arr) {
  console.log(arr, 'arrrrrr')
  let apiResult = process.env.VUE_APP_API_HOST ? await checkDomainAvailability(process.env.VUE_APP_API_HOST) : false
  console.log(apiResult, 'apiResultapiResult')
  // 如果当前域名不可用则遍历配置域名
  if (!apiResult) {
    for (const item of arr) {
      if (apiResult) break // 支持中断
      console.log(item) // 输出: 1, 2
      apiResult = await checkDomainAvailability(item)
      if (apiResult) {
        setApi_host(item)
      }
    }
  }
}
async function checkDomainAvailability(url) {
  try {
    const response = await fetch(url, {
      method: 'HEAD', // 轻量请求，仅获取响应头
      mode: 'no-cors' // 绕过CORS限制（注意：仅能检测网络连通性）
    })
    // 若收到响应（无论状态码），说明域名可达
    console.log('域名可访问')
    return true
  } catch (error) {
    // 捕获网络错误（如DNS解析失败、连接超时）
    console.error('域名不可达:', error.message)
    return false
  }
}
